module.exports = __webpack_public_path__ + "img/image168.e95414b3.jpg";